export default [
  {
    path: "/CloudFairIndex", //云上洽谈首页
    name: "CloudFairIndex",
    component: () => import("@/view/CloudFair/index.vue"),
    meta: {
      title: "云上洽谈会_中国国际投资贸易洽谈会",
      keepAlive: true
    }
  },
  {
    path: "/Showroom", //云上展厅
    name: "Showroom",
    component: () => import("@/view/CloudFair/Showroom/index.vue")
  },
  {
    path: "/Policy/:name?", //最新政策
    name: "Policy",
    component: () => import("@/view/CloudFair/Policy/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/PolicyDetail/:name?/:id", //最新政策 详情
    name: "PolicyDetail",
    component: () => import("@/view/CloudFair/Policy/detail.vue")
  },
  {
    path: "/Information/:name?", //投资资讯
    name: "Information",
    component: () => import("@/view/CloudFair/Information/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/InformationDetail/:name?/:id", //投资资讯 详情
    name: "InformationDetail",
    component: () => import("@/view/CloudFair/Information/detail.vue")
  },
  {
    path: "/HotProject", //推荐项目
    name: "HotProject",
    component: () => import("@/view/CloudFair/HotProject/index.vue")
  },
  
  {
    path: "/Government", //政府招商
    name: "Government",
    component: () => import("@/view/CloudFair/Government/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/InvestmentProject", //投资项目
    name: "InvestmentProject",
    component: () => import("@/view/CloudFair/InvestmentProject/index.vue")
  },

  {
    path: "/Meeting", //会议
    name: "Meeting",
    component: () => import("@/view/CloudFair/Meeting/index.vue")
  },
  {
    path: "/Appointment", //要客预约
    name: "Appointment",
    component: () => import("@/view/CloudFair/Appointment/index.vue")
  },
  {
    path: "/Business", //商务部投促局
    name: "Business",
    component: () => import("@/view/CloudFair/Business/main.vue"),
    // meta: {
    //   title: "商务部投促局_中国国际投资贸易洽谈会",
    //   keepAlive: false
    // },
    children: [
      {
        path: "/BusinessWorkTrends/:name?", //工作动态
        name: "BusinessWorkTrends",
        component: () =>
          import("@/view/CloudFair/Business/BusinessWorkTrends.vue"),
          meta: {
            keepAlive: true
          }
      },
      {
        path: "/BusinessNotice/:name?", //通知公告
        name: "BusinessNotice",
        component: () => import("@/view/CloudFair/Business/BusinessNotice.vue"),
        meta: {
          keepAlive: true
        }
      },
      {
        path: "/BusinessStatisData/:name?", //统计数据
        name: "BusinessStatisData",
        component: () =>
          import("@/view/CloudFair/Business/BusinessStatisData.vue"),
          meta: {
            keepAlive: true
          }
      },
      {
        path: "/BusinessProject/:name?", //项目投资
        name: "BusinessProject",
        component: () => import("@/view/CloudFair/Business/BusinessProject.vue"),
        meta: {
          keepAlive: true
        }
      }
    ]
  },
  {
    path: "/BusinessStatisData/detail/:name?/:id?", //统计数据 详情
    name: "BusinessStatisDataDetail",
    component: () => import("@/view/CloudFair/Business/detail/staticData.vue")
  },
  {
    path: "/BusinessProject/detail/:name?/:id?", //项目 详情
    name: "BusinessProjectDetail",
    component: () => import("@/view/CloudFair/Business/detail/project.vue")
  },
  {
    path: "/BusinessNotice/detail/:name?/:id?", //通知公告详情
    name: "BusinessNoticeDetail",
    component: () => import("@/view/CloudFair/Business/detail/notice.vue")
  },
  {
    path: "/BusinessWorkTrends/detail/:name?/:id?", //工作动态 详情
    name: "BusinessWorkTrendsDetail",
    component: () => import("@/view/CloudFair/Business/detail/WorkTrends.vue")
  }
];



// WEBPACK FOOTER //
// ./src/router/cloudFair/cloudFair.js